// extracted by mini-css-extract-plugin
export default {"quiz_question":"t1","question_subheader":"u1","why_popup":"v1","why_underline":"w1","MyClassEnterDone":"x1","WhyAskEnterDone":"y1","WhyUnderlineEnterDone":"z1","main_question":"A1"};
    if(module.hot) {
      // 1743628930066
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  